import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Header from './Header';
import Footer from './Footer';
import PhoneWidget from '../VoiceAgent/PhoneWidget';
import VoiceAssistant from '../VoiceAgent/VoiceAssistant';
import ChatBotManager from '../ChatBot/ChatBotManager';
import ScrollToTop from '../Common/ScrollToTop';
import SafariBuilderButton from '../CustomSafari/SafariBuilderButton';
import OnboardingPrompt from '../Onboarding/OnboardingPrompt';
import TourOverlay from '../Onboarding/TourOverlay';
import SafariAssistant from '../Assistant/SafariAssistant';
import FloatingHub from './FloatingHub';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { actualTheme } = useTheme();
  const [isVoiceAssistantOpen, setIsVoiceAssistantOpen] = useState(false);

  const handleCallStart = () => {
    setIsVoiceAssistantOpen(true);
  };

  const handleCallEnd = () => {
    setIsVoiceAssistantOpen(false);
  };

  return (
    <div className={`min-h-screen flex flex-col transition-all duration-300 ${actualTheme === 'dark' ? 'bg-slate-900' : 'bg-neutral-50'
      }`}>
      <Header />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />

      {/* Voice Assistant Components disabled as requested */}
      {/* <PhoneWidget
        onCallStart={handleCallStart}
        onCallEnd={handleCallEnd}
      />
      <VoiceAssistant
        isOpen={isVoiceAssistantOpen}
        onClose={() => setIsVoiceAssistantOpen(false)}
      /> */}

      {/* ChatBot Manager disabled as requested */}
      {/* <ChatBotManager /> */}

      <FloatingHub />
      <ScrollToTop />
      <SafariBuilderButton />
      <OnboardingPrompt />
      <TourOverlay />
      <SafariAssistant />
    </div>
  );
};

export default Layout;
